export function pageCount(total: number, pageSize: number) {
  if (pageSize <= 0) return 1
  return Math.max(1, Math.ceil(total / pageSize))
}

export function safePage(page: number, total: number, pageSize: number) {
  const count = pageCount(total, pageSize)
  return Math.min(Math.max(page, 0), count - 1)
}

export function pageItems<T>(items: readonly T[], page: number, pageSize: number) {
  const clampedPage = safePage(page, items.length, pageSize)
  const count = pageCount(items.length, pageSize)
  return {
    pageItems: items.slice(clampedPage * pageSize, clampedPage * pageSize + pageSize),
    page: clampedPage,
    pageCount: count,
  }
}
